var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequredusers = function SvgRequredusers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#989696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 3.628a3.333 3.333 0 1 1 0 4.41m2.5 9.462h-10v-.833a5 5 0 1 1 10 0zm0 0h5v-.833a5 5 0 0 0-7.5-4.331m.833-6.503a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0"
  })));
};
export default SvgRequredusers;